// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_CriarReciboInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /compromissos/criarRecibo
 *
 * Validates input for creating a receipt document from HTML content.
 */
import { registerContract } from './validate'

export interface Compromissos_CriarReciboInput {
HTML: string
owner_id: number
}

registerContract('Compromissos_CriarReciboInput', {
  HTML:     { type: 'string',  required: true },
  owner_id: { type: 'number',  required: true },
})
